import { getParametersFromURL, nextStepCredStepper, removeUrlWithoutReload, } from "../../../configs/utils";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { ROUTE } from "../../../routes";
import { CreditApplicationStepId, DigioKycStatus } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
let currentStepId;
let isFromCoBorrower = false;
export const successVerification = async (action, _datastore, { network, navigateWithClear }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    let routeObj;
    if (currentStepId) {
        routeObj = await nextStepCredStepper(currentStepId);
    }
    else {
        routeObj = await nextStepCredStepper();
    }
    removeUrlWithoutReload("kyc_response");
    removeUrlWithoutReload("status");
    removeUrlWithoutReload("digio_doc_id");
    removeUrlWithoutReload("message");
    await navigateWithClear(routeObj.routeId, {});
};
export const onLoad = async (action, _datastore, { network, showPopup, navigateWithClear }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    let coBorrowerAccountId;
    let coBorrowerApplicationId;
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerApplicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        coBorrowerApplicationId = user.linkedApplications[0].applicationId;
    }
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${coBorrowerApplicationId}`, { headers: await getAppHeader() });
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = user.linkedApplications[0].currentCoBorrowerAccountId;
    }
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    let url;
    const params = getParametersFromURL();
    if (params.origin && params['origin'] === 'CO_BORROWER') {
        isFromCoBorrower = true;
        url = `${api.coBorrowerDigioKycCheckRequestStatusOnCallBackV2}${coBorrowerApplicationId}/${coBorrowerAccountId}`;
    }
    else {
        url = `${api.digioKycCheckRequestStatusOnCallBackV2}${applicationId}`;
    }
    const failedObj = {
        showFailedModal: false,
        failedTitle: "",
        failedSubTitle: "",
        failedButtonTitle: "",
    };
    const routeObj = await nextStepCredStepper();
    removeUrlWithoutReload("kyc_response");
    removeUrlWithoutReload("status");
    removeUrlWithoutReload("digio_doc_id");
    removeUrlWithoutReload("message");
    removeUrlWithoutReload("origin");
    network.get(url, {
        headers: await getAppHeader(),
    }).then(async (response) => {
        if (response.status === 200) {
            if (response.data.stepResponseObject ===
                DigioKycStatus.COMPLETED) {
                const currentStepIdOfMainBorrower = response?.data?.updatedApplicationObj?.currentStepId;
                const successObj = {
                    showSuccessModal: false,
                    successTitle: "",
                    successSubTitle: "",
                    successButtonTitle: "",
                    currentStepId: currentStepIdOfMainBorrower
                };
                successObj.showSuccessModal = true;
                lenderId === 'Tata' ? successObj.successTitle = "Aadhaar verified successfully" : successObj.successTitle = "Aadhaar and PAN verified successfully";
                successObj.successButtonTitle = "Continue";
                if (isFromCoBorrower) {
                    currentStepId = response.data.updatedApplicationObj.currentStepId;
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        successModal: true,
                        successTitle: 'KYC done successfully',
                        successSubTitle: ' ',
                        successButtonTitle: 'Continue',
                        currentStepId: currentStepId
                    });
                }
                else {
                    return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, successObj);
                }
            }
            else if (response.data.stepResponseObject ===
                DigioKycStatus.EXPIRED ||
                response.data.stepResponseObject ===
                    DigioKycStatus.FAILED) {
                failedObj.showFailedModal = true;
                failedObj.failedTitle = "Something went wrong";
                failedObj.failedButtonTitle = "Try again";
                if (isFromCoBorrower) {
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'Something went wrong',
                        failedSubTitle: 'KYC verification is required for the completion of your loan application',
                        failedButtonTitle: 'Try again'
                    });
                    currentStepId = response.data.updatedApplicationObj.currentStepId;
                }
                else {
                    return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, failedObj);
                }
            }
            else if (response.data.stepResponseObject === DigioKycStatus.CREATED) {
                failedObj.showFailedModal = true;
                failedObj.failedTitle = "KYC verification canceled";
                failedObj.failedSubTitle = "KYC verification is required for the completion of your loan application";
                failedObj.failedButtonTitle = "Try again";
                if (isFromCoBorrower) {
                    await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                        failedModal: true,
                        failedTitle: 'KYC verification canceled',
                        failedSubTitle: 'KYC verification is required for the completion of your loan application',
                        failedButtonTitle: 'Try again'
                    });
                    console.warn("THE RESPONSE OBJECT IS 1", response);
                    currentStepId = response.data.updatedApplicationObj.currentStepId;
                }
                else {
                    return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, failedObj);
                }
            }
        }
        else {
            if (response.response.status === 400) {
                const errorCode = response.response.data.voltErrorCode;
                if (errorCode === "KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO") {
                    const failureJson = JSON.parse(response.response.data.message);
                    const heading = failureJson.nameMatchFailureDetails.description;
                    const key1 = failureJson.nameMatchFailureDetails.source.description;
                    const value1 = failureJson.nameMatchFailureDetails.source.value;
                    const key2 = failureJson.nameMatchFailureDetails.target.description;
                    const value2 = failureJson.nameMatchFailureDetails.target.value;
                    await navigateWithClear(ROUTE.NAME_MISMATCH, {
                        heading: heading,
                        key1: key1,
                        value1: value1,
                        key2: key2,
                        value2: value2,
                        isFromKYC: true,
                        voltErrorCode: errorCode
                    });
                }
                else if (errorCode === "DIGIO_PAN_MISMATCH") {
                    failedObj.showFailedModal = true;
                    failedObj.failedTitle = "Verification failed!";
                    failedObj.failedSubTitle = "PAN card number not matching with account details. Kindly check the document and try again.";
                    failedObj.failedButtonTitle = "Try again";
                    if (isFromCoBorrower) {
                        await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            failedModal: true,
                            failedTitle: 'Verification failed!',
                            failedSubTitle: "PAN card number not matching with account details. Kindly check the document and try again.",
                            failedButtonTitle: 'Try again'
                        });
                        currentStepId = CreditApplicationStepId.CO_BORROWER_KYC_DOCUMENTS;
                    }
                    else {
                        return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, failedObj);
                    }
                }
                else if (errorCode === 'MISMATCH_DETECTED') {
                    failedObj.showFailedModal = true;
                    failedObj.failedTitle = "PAN is not linked with the provided Aadhaar";
                    failedObj.failedSubTitle = response.response.data.message;
                    failedObj.failedButtonTitle = "Try again";
                    return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, failedObj);
                }
                else {
                    failedObj.showFailedModal = true;
                    failedObj.failedTitle = "Verification failed!";
                    failedObj.failedSubTitle = response.response.data.message;
                    failedObj.failedButtonTitle = "Try again";
                    if (isFromCoBorrower) {
                        await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, {
                            failedModal: true,
                            failedTitle: 'Verification failed!',
                            failedSubTitle: response.response.data.message,
                            failedButtonTitle: 'Try again'
                        });
                        console.warn("THE RESPONSE OBJECT IS 2", response);
                        currentStepId = response.data.updatedApplicationObj.currentStepId;
                    }
                    else {
                        return navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, failedObj);
                    }
                }
            }
        }
    });
};
export const failedVerification = async (action, _datastore, { network, navigateWithClear }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    let routeObj;
    console.warn("CURRENT REP", currentStepId);
    if (currentStepId) {
        routeObj = await nextStepCredStepper(currentStepId);
    }
    else {
        routeObj = await nextStepCredStepper();
    }
    removeUrlWithoutReload("kyc_response");
    removeUrlWithoutReload("status");
    removeUrlWithoutReload("digio_doc_id");
    removeUrlWithoutReload("message");
    console.warn("CURRENT ROUTE", routeObj);
    if (isFromCoBorrower) {
        await navigateWithClear(ROUTE.CO_BORROWER_KYC_DIGIO_BASE);
    }
    else {
        await navigateWithClear(routeObj.routeId);
    }
};
